









import { Vue, Component, Prop, Model, Emit, Inject } from 'vue-property-decorator'
import { Search } from 'vant'
import { isMmz } from '@/app/core/utils/cookie'
import { namespace } from 'vuex-class'
const searchModule = namespace('search') //vuex

@Component({
  components: {
    [Search.name]: Search
  }
})
export default class SearchBar extends Vue {
  @Prop({ default: false }) readonly showCancel!: boolean //是否展示右侧搜索按钮
  @Prop({ default: false }) readonly autoFocus!: boolean //是否自动对焦
  @Prop({ default: false }) readonly isSearchResPage!: boolean //是否用在搜索结果页
  @Prop({ default: false }) readonly isFromSearchPage!: boolean //前一个路由页面是否是搜索前置页
  @Model('input', { default: '' }) searchKey!: string //默认展示搜索关键字

  onAutoFocus = this.autoFocus
  shareEarn = this.$route.query.shareEarn

  //vuex 声明
  @searchModule.Action addSearchRecords!: (searchKey: string) => void

  activated() {
    this.onAutoFocus = !this.isSearchResPage
    this.$nextTick()
  }

  @Emit('input')
  changed(content: string) {
    return content
  }

  onFoucs() {
    if (this.isSearchResPage) {
      if (this.isFromSearchPage) {
        this.onCancel()
      } else {
        this.$router.replace({ name: 'search', query: { refresh: 'no', cmd: 'share', sharetype: '0', shareEarn: this.shareEarn } })
      }
    }
  }

  @Inject({ from: 'onSearchEP', default: null }) onSearchEP!: any
  get onSearchExposure() {
    return this.onSearchEP && this.onSearchEP({ keyword: this.searchKey })
  }
  onSearch() {
    if (this.searchKey && this.searchKey.length > 0) {
      this.addSearchRecords(this.searchKey)
      this.$emit('onSearch', this.searchKey)
      const isMMz = isMmz()
      this.$router.push({ name: 'searchRes', query: { searchKey: this.searchKey, refresh: 'no', cmd: 'share', sharetype: '0', shareEarn: this.shareEarn, hzwMmz: isMMz ? '1' : '' } })
    }
  }

  onCancel() {
    console.log(history.length)
    history.go(-1)
  }
}
